import { DisputesMFEConfig } from 'digital-disputes'
import getLanguageFromStorage from 'helpers/getLanguageFromStorage'
import { MFEConfig } from 'syf-js-utilities/typings/mfeConfig'
import isProductionEnv from './isProductionEnv'

import config from '../const/config'

type PromotionsMFEConfig = MFEConfig & {
  hosts: MFEConfig['hosts'] & { serviceFile: URL }
}

type MFEConfigMap = {
  mfe: MFEConfig
  mma: PromotionsMFEConfig
  disputes: DisputesMFEConfig
  customCardArt: MFEConfig
}

const getServiceFilesMmaUrl = (): string => {
  if (isProductionEnv()) {
    return 'https://images.synchronycredit.com/serviceFiles/json/prod-mma-config.json'
  }
  return 'https://images.synchronycredit.com/serviceFiles/json/nonprod-mma-config.json'
}

const getServiceFilesDisputesUrl = (): string => {
  if (isProductionEnv()) {
    return 'https://images.synchronycredit.com/serviceFiles/json/prod-disputes-config.json'
  }
  return 'https://images.synchronycredit.com/serviceFiles/json/nonprod-disputes-config.json'
}

const serviceFilesCardArtURL =
  'https://images.synchronycredit.com/serviceFiles/json/custom-card-art-config.json'

const getMFEConfig = <T extends keyof MFEConfigMap>(
  mfeType: T
): MFEConfigMap[T] => {
  const baseMfeConfig = {
    hosts: {
      apigee: new URL(config.API_HOST),
      assets: new URL(config.ASSETS_HOST)
    },
    apiErrorCallback: (error) => error,
    lang: getLanguageFromStorage()
  }

  if (mfeType === 'mma') {
    return {
      ...baseMfeConfig,
      hosts: {
        ...baseMfeConfig.hosts,
        serviceFile: new URL(getServiceFilesMmaUrl())
      }
    }
  }
  if (mfeType === 'disputes') {
    return {
      ...baseMfeConfig,
      hosts: {
        ...baseMfeConfig.hosts,
        serviceFile: new URL(getServiceFilesDisputesUrl())
      }
    }
  }

  if (mfeType === 'customCardArt') {
    return {
      ...baseMfeConfig,
      hosts: {
        ...baseMfeConfig.hosts,
        serviceFile: new URL(serviceFilesCardArtURL)
      }
    }
  }

  return baseMfeConfig as MFEConfigMap[T]
}

export default getMFEConfig
